export var formDefaultEmailAddress = 'email@jove.co';
export var formDefaultWebsiteAddress = 'https://www.jove.co';
export var formValidateFailPromptText = 'The form data is filled in incorrectly, please check and try again.';
export var JOVE_LOGO_RED_URL = 'https://storage.googleapis.com/jove-public-images/logos/jove-logo-red.png';
export var getSupportRegionMap = function getSupportRegionMap() {
  return {
    GB: {
      label: 'United Kingdom',
      value: 'GB'
    },
    EU: {
      label: 'European Union',
      value: 'EU'
    },
    US: {
      label: 'United States',
      value: 'US'
    }
  };
};
export var getSupportRegionList = function getSupportRegionList() {
  return Object.values(getSupportRegionMap());
};